// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 알림 버튼 공통 컴포넌트 */
.ab-wrap {
  display: inline-block;
}

.ab-btn {
  background: transparent;
  border: none;
  padding: 0 1px;
  cursor: pointer;
  font-size: 12px;
  width: 14px;
  height: 14px;
  line-height: 1;
  vertical-align: middle;
  border-radius: 3px;
  transition: opacity 0.15s, transform 0.1s;
}

.ab-btn:hover {
  transform: scale(1.2);
}

/* 알림 미설정 */
.ab-none {
  color: #ddd;
  opacity: 0.4;
}

/* 알림 설정됨 + 비활성 */
.ab-off {
  color: #aaa;
  opacity: 0.6;
}

/* 알림 설정됨 + 활성 */
.ab-on {
  color: #52a8ec;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/AlertButton.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,UAAU;AACZ","sourcesContent":["/* 알림 버튼 공통 컴포넌트 */\n.ab-wrap {\n  display: inline-block;\n}\n\n.ab-btn {\n  background: transparent;\n  border: none;\n  padding: 0 1px;\n  cursor: pointer;\n  font-size: 12px;\n  width: 14px;\n  height: 14px;\n  line-height: 1;\n  vertical-align: middle;\n  border-radius: 3px;\n  transition: opacity 0.15s, transform 0.1s;\n}\n\n.ab-btn:hover {\n  transform: scale(1.2);\n}\n\n/* 알림 미설정 */\n.ab-none {\n  color: #ddd;\n  opacity: 0.4;\n}\n\n/* 알림 설정됨 + 비활성 */\n.ab-off {\n  color: #aaa;\n  opacity: 0.6;\n}\n\n/* 알림 설정됨 + 활성 */\n.ab-on {\n  color: #52a8ec;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
